import { Tab, Tabs, styled } from '@mui/material'
import { useTranslation } from 'react-i18next'

const MOBILE_BREAKPOINT = 760

type OrderDialogTab = 'order' | 'materials' | 'gpsr'

const DialogTabsHeader = styled('div')(({ theme }) => ({
  background: 'rgba(0, 0, 0, 0.06)',
  padding: theme.spacing(0, 9, 0, 3),

  ['@media (max-width: ' + MOBILE_BREAKPOINT + 'px)']: {
    padding: theme.spacing(0, 7, 0, 0)
  }
}))

interface Props {
  value: OrderDialogTab
  onChange: (value: OrderDialogTab) => void
}

export default function OrderDialogTabsHeader(props: Props) {
  const [t] = useTranslation('account-v2')

  return <DialogTabsHeader>
    <Tabs
      value={props.value}
      onChange={(_e, value: OrderDialogTab) => props.onChange(value)}
      sx={{ minHeight: 48 }}
    >
      <Tab value="order" label={t('Order')} sx={{ minHeight: 48 }} />
      <Tab value="materials" label={t('Materials')} sx={{ minHeight: 48 }} />
      <Tab value="gpsr" label={t('GPSR Info')} sx={{ minHeight: 48 }} />
    </Tabs>
  </DialogTabsHeader>
}
